module.exports = __webpack_public_path__ + "static/media/select-bottom.a05ffedd.svg";